import React from 'react'

import { Outlet } from 'react-router-dom'

/**
 * Layout wrapper for the campaign create/edit flow.
 * Previously wrapped children with CampaignFlowProvider (React Context).
 * Now uses Redux for state management, so no provider is needed.
 */
export const CampaignFlowLayout: React.FC = () => {
	return <Outlet />
}
